import { Droplet } from 'lucide-react';
import GenericModulePage from './GenericModulePage';
import { bloodBankAPI } from '../lib/api';

const config = {
  title: 'Blood Bank',
  subtitle: 'Donor registry and unit inventory.',
  icon: Droplet,
  permPrefix: 'bloodbank',
  testId: 'bloodbank',
  idLabel: 'Unit',
  fields: [
    { key: 'donor_name', label: 'Donor Name', type: 'text', required: true, listColumn: true },
    { key: 'donor_phone', label: 'Donor Phone', type: 'text' },
    { key: 'blood_group', label: 'Blood Group', type: 'select', options: ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'], required: true, listColumn: true },
    { key: 'component', label: 'Component', type: 'select', options: ['Whole Blood', 'Packed RBC', 'Platelets', 'FFP', 'Cryoprecipitate'], required: true, listColumn: true },
    { key: 'unit_no', label: 'Unit No', type: 'text', listColumn: true },
    { key: 'volume_ml', label: 'Volume (mL)', type: 'number' },
    { key: 'collected_on', label: 'Collected On', type: 'date', listColumn: true },
    { key: 'expiry_date', label: 'Expiry Date', type: 'date', listColumn: true },
    { key: 'status', label: 'Status', type: 'select', options: ['Available', 'Reserved', 'Issued', 'Discarded'], listColumn: true },
    { key: 'issued_to', label: 'Issued To (Patient)', type: 'text' },
  ],
};

export default function BloodBankPage() { return <GenericModulePage config={config} apiClient={bloodBankAPI} />; }
